/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sg_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug Generator`)
};

const es_sg_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de slug`)
};

const de_sg_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug-Generator`)
};

const nl_sg_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL Slug Generator`)
};

const fr_sg_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de slug`)
};

const it_sg_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di slug`)
};

const pt_br2_sg_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Slug`)
};

const pt_sg_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Slugs`)
};

const ja_sg_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スラグジェネレータ`)
};

const zh_sg_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug 生成器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sg_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sg_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sg_tool_name", locale)
	if (locale === "en") return en_sg_tool_name(inputs)
	if (locale === "es") return es_sg_tool_name(inputs)
	if (locale === "de") return de_sg_tool_name(inputs)
	if (locale === "nl") return nl_sg_tool_name(inputs)
	if (locale === "fr") return fr_sg_tool_name(inputs)
	if (locale === "it") return it_sg_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_sg_tool_name(inputs)
	if (locale === "pt") return pt_sg_tool_name(inputs)
	if (locale === "ja") return ja_sg_tool_name(inputs)
	return zh_sg_tool_name(inputs)
};